"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pointer = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var constants_1 = require("./constants");

exports.Pointer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  border-radius: ", ";\n  background: ", ";\n  width: ", ";\n  height: ", ";\n  transform: rotate(45deg);\n"], ["\n  position: absolute;\n  border-radius: ", ";\n  background: ", ";\n  width: ", ";\n  height: ", ";\n  transform: rotate(45deg);\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('LINE.RADIUS.SMALL', theme);
}, function (_a) {
  var theme = _a.theme,
      isInverse = _a.isInverse;
  return isInverse ? (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.WHITE', theme) : (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.DARK', theme);
}, constants_1.TAIL_SIZE_REM, constants_1.TAIL_SIZE_REM);
var templateObject_1;